import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow, useIonViewDidEnter } from "@ionic/react";
import { FC, useState } from "react";
import { translation } from "../../models/translation";
import { fetchAllNews } from "../../services/new_service";
import Footer from "../../components/Footer";


const AllNews: FC = () => {


    const siteText = translation();

    const [lan] = useState(siteText.lan);



    const [news, setNews] = useState<any>(null);

    useIonViewDidEnter(() => {
        fetchAllNews().then(
            m => {
                setNews(m.message);
            }
        )
        return () => {
        };
    }, [])

    function formatDateToDayMonthYear(dateStr: any) {
        // Convert string to Date object
        let dateObj = new Date(dateStr);

        // Get day, month, and year
        let day = dateObj.getDate();
        let month = dateObj.getMonth() + 1; // Adding 1 since getMonth() returns zero-based month index
        let year = dateObj.getFullYear();

        // Format the date
        let formattedDate = day + "-" + month + "-" + year;

        return formattedDate;
    }


    return (
        <IonPage className="sw_sp_md">
            <IonContent >
                <div className="mainContent">
                    <IonGrid className="">
                        {
                            news &&
                            <>
                                <IonRow>
                                    <IonCol className="ion-text-center sw_mb_lg">
                                        <h1 className="ion-margin-top">{siteText.feedsListPageTitle}</h1>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    {
                                        !news ? <></> :
                                            news.map((relFeed: any) => {
                                                return (
                                                    <IonCol sizeXs="12" sizeSm="6" sizeMd="4" key={relFeed.id}>
                                                        <IonCard routerLink={`${lan}/articles/${relFeed.id}`} className="ion-margin-bottom" key={relFeed.id} >
                                                            <IonCardHeader>
                                                                {!relFeed._embedded['wp:featuredmedia'] ? <></> :
                                                                    <IonImg src={relFeed._embedded['wp:featuredmedia'][0].source_url}></IonImg>
                                                                }

                                                                <IonCardTitle dangerouslySetInnerHTML={{ __html: relFeed.title.rendered }}></IonCardTitle>
                                                                {/*!relFeed._embedded['wp:term'] ? <></> :
                                                                    <p>{relFeed._embedded['wp:term'][0][0].name}</p>
                                                            */}
                                                            </IonCardHeader>

                                                            <IonCardContent>
                                                                <div dangerouslySetInnerHTML={{ __html: relFeed.excerpt.rendered }}></div>
                                                                <em>{siteText.newsPublishDateTitle}: {formatDateToDayMonthYear(relFeed.date)}</em>
                                                            </IonCardContent>
                                                        </IonCard>
                                                    </IonCol>
                                                )
                                            })
                                    }

                                </IonRow>
                            </>
                        }

                    </IonGrid>
                </div>

                <Footer></Footer>
            </IonContent>
        </IonPage >
    )

}

export default AllNews;